import React from "react";
import styled from 'styled-components'

const DivStyled = styled.div`

    &.item-test{
        width: 33.33%;
        padding: 10px;

        @media (max-width: 768px){

            width: 100%;
            padding: 10px;
            
        }

        .box{
            border: 1px solid #cacaca;
            border-left: 4px solid #66279b;
            padding: 4px 8px;
            transition: all .2s ease;
            cursor: pointer;

            p {
                display: block;
                margin-block-start: 1em;
                margin-block-end: 1em;
                margin-inline-start: 0px;
                margin-inline-end: 0px;
                margin: 0;
                padding: 0;
            }
        }

        .nao-visualizado {
            background-color: #f9f6ff;
        }

        .number {
            font-size: 12px;
            color: #505050;
            font-weight: 300;
            // font-family: pantonregular;
        }

        .student {
            color: ${(props) => props.theme.main.mainGreen};
            font-size: 18px;
            font-weight: 600;
            // font-family: pantonbold;
            margin-top: 8px;
            max-width: 245px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .value {
            color: #66279b;
            font-size: 16px;
            font-weight: 600;
            // font-family: pantonbold;
        }

        .level {
            color: #66279b;
            font-size: 23px;
            font-weight: 700;
            // font-family: pantonextrabold;
        }

        .in-progress {
            color: #66279b;
            font-size: 18px;
            font-weight: 300;
            // font-family: pantonregular;
        }
    }
`;

export default (node: any) => {
    return <DivStyled className="item-test">
        {node.children}
    </DivStyled>
};